import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import AccountNumber from "./AccountNumber";
import AccountTypeButton from "./AccountTypeButton";
import HolderTypeButton from "./HolderTypeButton";
import NameInput from "./NameInput";
import RoutingNumber from "./RoutingNumber";
import { ButtonsWrapper, Inside, Nickname } from "./styledComponents";

export default function StaxACHFields({ cardType }) {
  return (
    <Inner>
      <Nickname>
        {cardType[0].toUpperCase() + cardType.slice(1)} Account
      </Nickname>

      <Gap />
      <AccountNumber />
      <Gap />

      <RoutingNumber />

      <Gap />

      <ButtonsWrapper>
        <AccountTypeButton />
        <HolderTypeButton />
      </ButtonsWrapper>

      <Gap />

      <NameInput />

      {/* {isEditing && <NameInput />} */}
    </Inner>
  );
}

StaxACHFields.propTypes = {
  cardType: PropTypes.string,
};

const Inner = styled(Inside)`
  padding: 0 32px;
  flex: 1;
  margin-top: 28px;
`;

const Gap = styled.div`
  margin-top: 2px;
`;
